module.exports = __webpack_public_path__ + "img/icon_gg.a70e2b6a.png";